export type AiSummaryKind =
  | "health_overview"
  | "rmr_summary"
  | "rmr_inbody_summary"
  | "amr_summary"
  | "progress_summary_1"
  | "progress_summary_2"
  | "biomarkers_summary";

export type AiSummaryOption = {
  kind: AiSummaryKind;
  label: string;
  description: string;
  implemented: boolean;
};

export const AI_SUMMARY_OPTIONS: AiSummaryOption[] = [
  {
    kind: "health_overview",
    label: "Health overview",
    description: "A complete overview of the client's health data",
    implemented: true,
  },
  {
    kind: "rmr_summary",
    label: "RMR summary",
    description: "Resting metabolism and nutrition targets",
    implemented: true,
  },
  {
    kind: "rmr_inbody_summary",
    label: "RMR + InBody summary",
    description: "Resting metabolism and body-composition connections",
    implemented: true,
  },
  {
    kind: "amr_summary",
    label: "AMR summary",
    description: "Active metabolism, training zones, and fueling",
    implemented: true,
  },
  {
    kind: "progress_summary_1",
    label: "Progress Summary 1",
    description:
      "Progress across resting, exercise, and body-composition tests",
    implemented: true,
  },
  {
    kind: "progress_summary_2",
    label: "Progress Report 2",
    description: "Blood biomarker trends across body systems",
    implemented: true,
  },
  {
    kind: "biomarkers_summary",
    label: "Biomarkers summary",
    description: "Coming soon",
    implemented: false,
  },
];

export const getAiSummaryOption = (kind: AiSummaryKind): AiSummaryOption =>
  AI_SUMMARY_OPTIONS.find((option) => option.kind === kind) ??
  AI_SUMMARY_OPTIONS[0];
